import React from "react";
import "../../../../assets/css/page/CommonModal.scss";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { ReactComponent as BinIcon } from "../../../../assets/Images/Bin.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/Images/CrossIcon.svg";
import { buttonStyles } from "../../../../assets/MUIStyles/popupStyles";
import { LoadingSlides } from "../Common";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";

const DeletePopup = ({
  message,
  show,
  toggle,
  handleDelete,
  spin = false,
  heading = "Are you sure you want to delete?",
  deleteText = "Delete",
  additionalHtml = <></>,
  Icon = BinIcon,
  headerText = "Delete",
}) => {
  return (
    <Dialog
      open={show}
      onClose={toggle}
      scroll="body"
      classes={{ paper: "common-modal-450" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            maxWidth: 450,
            width: "100%",
          },
        },
      }}
    >
      <DialogTitle
        className="new-modal-header popup-header"
        sx={commonStyles.popUpcontainer}
      >
        <span className="font-14-600-grey">{headerText}</span>
        <IconButton onClick={toggle} className="modal-cross-icon" size="small">
          <CrossIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        className="new-modal-body"
        sx={{ padding: "1rem 2rem !important" }}
      >
        <Box className="flex-column" sx={{ justifyContent: "center" }}>
          <Box className="flex-xy-center">
            <Box
              className="flex-column-center"
              sx={{
                width: "260px",
              }}
            >
              <Icon style={{ height: "200px", width: "200px" }} />
              <Typography
                className="font-18-600-grey"
                sx={{ mt: 2, textAlign: "center" }}
              >
                {heading}
              </Typography>
            </Box>
          </Box>

          <Typography
            className="font-14-lightgrey"
            sx={{ mt: 1, mb: 1, textAlign: "center" }}
          >
            {message}
          </Typography>
        </Box>

        <Box>{additionalHtml}</Box>

        <Box className="flex-between" sx={{ mt: 3, px: 1.5, mb: 2, gap: 2 }}>
          <Button sx={buttonStyles.cancel} onClick={toggle}>
            Cancel
          </Button>
          <Button
            disabled={spin}
            className="flex-xy-center"
            sx={buttonStyles.delete}
            onClick={handleDelete}
          >
            {spin ? <LoadingSlides bgColor="white" /> : deleteText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeletePopup;
